<template>
  <!--
    EL ENLACE DE PAGO COMO CÓDIGO QR

    Para cobrar en recepción sin datáfono: se enseña el QR en la pantalla, el huésped lo
    escanea con el móvil y paga en la página segura de la pasarela. El cobro se marca solo
    cuando llega el aviso de la pasarela, igual que si hubiera abierto el enlace por WhatsApp.
  -->
  <div class="qr-capa" @click.self="$emit('close')">
    <div class="qr-modal" role="dialog" aria-modal="true" aria-labelledby="qr-titulo">
      <h3 id="qr-titulo" class="qr-titulo">{{ $t("datafono.qr.title") }}</h3>
      <p class="qr-importe">{{ importe }}</p>
      <div class="qr-codigo">
        <vue-qr :text="url" :size="520" :margin="0" />
      </div>
      <p class="qr-texto">{{ $t("datafono.qr.text") }}</p>
      <div class="qr-acciones">
        <button type="button" class="qr-btn qr-btn--secundario" @click="copiar">
          {{ copiado ? $t("datafono.qr.copied") : $t("datafono.qr.copy") }}
        </button>
        <button type="button" class="qr-btn qr-btn--primario" @click="$emit('close')">{{ $t("datafono.qr.close") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import VueQr from "vue-qr";

export default {
  name: "QrDePagoModal",
  components: { VueQr },
  props: {
    url: { type: String, required: true },
    importe: { type: String, default: "" },
  },
  data() {
    return { copiado: false };
  },
  mounted() {
    window.addEventListener("keydown", this.alPulsarTecla);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.alPulsarTecla);
  },
  methods: {
    async copiar() {
      try {
        await navigator.clipboard.writeText(this.url);
        this.copiado = true;
      } catch {
        this.copiado = false;
      }
    },
    alPulsarTecla(e) {
      if (e.key === "Escape") this.$emit("close");
    },
  },
};
</script>

<style scoped>
.qr-capa {
  position: fixed;
  inset: 0;
  z-index: 2100;
  background: rgba(15, 23, 42, 0.36);
  display: flex;
  padding: 16px;
  overflow-y: auto;
  overscroll-behavior: contain;
  font-family: "DM Sans", system-ui, -apple-system, "Segoe UI", sans-serif;
}
.qr-modal {
  margin: auto;   /* centrada si cabe; si no, empieza arriba y la capa se desplaza */
  width: 100%;
  max-width: 360px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.14);
  padding: 24px 24px 20px;
  text-align: center;
}
.qr-titulo { margin: 0 0 4px; font-size: 16px; font-weight: 700; color: #0f172a; }
.qr-importe {
  margin: 0 0 16px;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.5px;
  font-variant-numeric: tabular-nums;
  color: #0f172a;
}
.qr-codigo {
  width: 240px;
  height: 240px;
  margin: 0 auto;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}
.qr-codigo ::v-deep img { width: 100%; height: 100%; display: block; }
.qr-texto { margin: 14px 0 0; font-size: 13px; line-height: 1.55; color: #475569; }
.qr-acciones { display: flex; justify-content: center; gap: 8px; margin-top: 18px; }
.qr-btn {
  font: inherit;
  font-size: 13.5px;
  font-weight: 600;
  border-radius: 9px;
  padding: 9px 16px;
  cursor: pointer;
}
.qr-btn:focus-visible { outline: 2px solid #673de6; outline-offset: 2px; }
.qr-btn--primario { border: 0; background: #1e293b; color: #fff; }
.qr-btn--secundario { border: 1px solid #e2e8f0; background: #fff; color: #1e293b; }
</style>
